import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { setParams } from '../../../redux/Slices/scrollSlice';
import { Button } from '../../../components/ui/Button';
import { ProgressSpinner } from 'primereact/progressspinner';

function SearchInput({ classes = null, isDisabled, content = null }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { params, isFetching } = useSelector(state => state.scroll);
    const [searchTerm, setSearchTerm] = useState("");

    // Debounce
    useEffect(() => {
        if (isEmpty(searchTerm)) return
        const delayDebounce = setTimeout(() => {
            dispatch(setParams({ ...params, search: searchTerm.trim() }));
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);

    const handleInput = () => {
        if (!isEmpty(searchTerm)) {
            dispatch(setParams({ ...params, search: searchTerm }))
        }
    }

    const resetInput = () => {
        setSearchTerm("")
        dispatch(setParams({ ...params, search: "" }))
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleInput()
        }
    };

    return (
        <div className={`relative  ${classes ? classes : "m-3"} `}>
            <input
                type="text"
                className={`form-control w-full pr-10 ${content === "links" ? "h-100" : "h-[42.2px]"}  ${classes ? "!rounded-[6px] !border-[#ced4da]" : ""}`}
                placeholder={t('common.search_placeholder')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={isDisabled}
                onKeyDown={handleKeyPress}
            />

            {isFetching ? (
                <ProgressSpinner
                    className='absolute right-2 top-1/2 -translate-y-1/2'
                    style={{ width: '30px', height: '30px' }}
                    strokeWidth="3"
                    fill="var(--surface-ground)"
                    animationDuration="2s"
                />
            ) : (
                !isEmpty(searchTerm) && (
                    <button
                        type="button"
                        onClick={resetInput}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-black"
                    >
                        ✕
                    </button>
                )
            )}

        </div>
    )
}

export default SearchInput
